import * as R from 'ramda';

export const getFileDisplayName: (fileName: string) => string = (
  fileName: string
) => {
  if (!fileName) return fileName;
  return R.pipe(R.split('/'), R.propOr('', '1'))(fileName) as string;
};
